import { reduxForm } from "redux-form";
import React, { Component } from "react";
import Grid from "@react/react-spectrum/Grid/js/Grid";
import GridColumn from "@react/react-spectrum/Grid/js/GridColumn";
import GridRow from "@react/react-spectrum/Grid/js/GridRow";
import DataSection from "../../comps/DataSection/DataSection";
import Dialog from "@react/react-spectrum/Dialog";
import Button from "@react/react-spectrum/Button";
import Heading from "@react/react-spectrum/Heading";
import Well from "@react/react-spectrum/Well";
import { Table, THead, TBody, TH, TR, TD } from "@react/react-spectrum/Table";
import { Provider, connect } from "react-redux";
import { unregisterField, getFormValues } from "redux-form";
import store from "../../store";
import formFields from "../config/formFields";
// import geoPolData from '../config/geoPolData';
import { Translate } from "react-redux-i18n";
import SaveNExit from "./save_n_ext";
import throwError, { toastPartnerApiFailure } from "../../comps/errorToast";

class AddContacts extends Component {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
    this.state = {
      contactCounter: 2,
      sectionValidation: {},
      popupValidation: {},
      popupMode: null,
      additionalContactSection1: [],
      additionalContactSection2: [],
      contactSuffix: [],
    };
    this.onLoad(this.state);
  }

  updateValidation = (name, value) => {
    let sectionValidation = this.state?.sectionValidation;
    sectionValidation[name] = value;
    this.setState({ sectionValidation: sectionValidation });
  };

  popupValidation = (name, value) => {
    let popupValidation = this.state?.popupValidation;
    popupValidation[name] = value;
    this.setState({ popupValidation: popupValidation });
    this.forceUpdate();
  };

  checkDisabled = () => {
    formFields.section9.map((obj) => {
      if (this.props?.formStates["contactId_0"]) {
        if (["firstName_0", "lastName_0"].includes(obj.name)) {
          obj.disabled = true;
        }
      }
      return null;
    });
    formFields.section10.map((obj) => {
      if (this.props?.formStates["contactId_0"]) {
        if (["email_0"].includes(obj.name)) {
          obj.disabled = true;
        }
      }
      return null;
    });
  };

  onLoad = (curState) => {
    this.checkDisabled();
    let suffix = [];
    let counter = 0;
    this.props?.formStates &&
      Object.keys(this.props?.formStates).map((ele) => {
        if (
          ele &&
          ele.startsWith("contactId") &&
          Boolean(this.props.formStates[ele])
        ) {
          if (Number(ele.split("_")[1]) >= 2) {
            counter = Number(ele.split("_")[1]);
            suffix.push(counter);
          }
        }
        return null;
      });
    counter += 1;
    let additionalContactSections = this.generateAdditionalContactFields(
      counter > 1 ? counter : this.state?.contactCounter,
    );
    this.state = {
      ...curState,
      ...additionalContactSections,
      contactSuffix: suffix,
      contactCounter: counter > 1 ? counter + 1 : this.state.contactCounter + 1,
    };
  };

  generateAdditionalContactFields = (counter) => {
    const additionalContactSection1 = [];
    const resetData = {};
    const section13 = JSON.parse(JSON.stringify(formFields.section13));
    const additionalContactSection2 = [];
    const section14 = JSON.parse(JSON.stringify(formFields.section14));

    section13?.map((obj) => {
      obj.name = obj.name + "_" + counter;
      // if ((obj.name === "firstName_" + counter || obj.name === "lastName_" + counter) && this.props.formStates && this.props.formStates["contactId_" + counter]) {
      //     obj.disabled = true;
      // }
      resetData[obj.name] = this.props?.formStates[obj.name]
        ? this.props?.formStates[obj.name]
        : null;
      additionalContactSection1.push(obj);
      return obj;
    });

    section14?.map((obj) => {
      obj.name = obj.name + "_" + counter;
      if (
        obj.name === "email_" + counter &&
        this.props?.formStates &&
        this.props?.formStates["contactId_" + counter]
      ) {
        obj.disabled = true;
      }
      resetData[obj.name] = this.props?.formStates[obj.name]
        ? this.props?.formStates[obj.name]
        : null;
      additionalContactSection2.push(obj);
      return obj;
    });

    return {
      additionalContactSection1: additionalContactSection1,
      additionalContactSection2: additionalContactSection2,
      resetData: resetData,
    };
  };

  additionalContactSave = () => {
    let body = {};
    this.state?.additionalContactSection1?.map((obj) => {
      body[obj.name.split("_")[0]] = this.props?.formStates[obj.name];

      return null;
    });

    this.state?.additionalContactSection2?.map((obj) => {
      body[obj.name.split("_")[0]] = this.props?.formStates[obj.name];

      return null;
    });

    body["additionalContactType"] = body["additionalContactType"].join(";");
    body["mainContactType"] = "Other";
    // additionalContactSection1
    if (this.state?.popupMode === "edit") {
      this.props.is_saving(true);
      this.props.connector.updateContact(
        this.onContactSaveComplete,
        body,
        this.props.formStates[
          "contactId_" + this.state.selectCounter.toString()
        ],
      );
    } else if (this.state?.popupMode === "add") {
      this.props.is_saving(true);
      this.props.connector.createContact(this.onContactSaveComplete, body);
    }
  };
  onContactSaveComplete = (response) => {
    //pass
    if (response?.contactId) {
      if (this.state.popupMode === "add") {
        let contactSuffix = this.state.contactSuffix;
        contactSuffix.push(this.state.contactCounter - 1);
        this.props.change(
          "contactId_" + (this.state.contactCounter - 1).toString(),
          response?.contactId,
        );
        this.setState({
          ...this.generateAdditionalContactFields(this.state.contactCounter),
          contactCounter: this.state.contactCounter + 1,
          popupMode: null,
        });
      } else {
        this.setState({
          ...this.generateAdditionalContactFields(
            this.state.contactCounter - 1,
          ),
          popupMode: null,
        });
      }
    } else {
      if (response?.errorCode || response?.isError) {
        toastPartnerApiFailure(response);
      }
      this.additionalContactCancel();
    }
    this.props.is_saving(false);
  };

  additionalContactCancel = () => {
    this.state.additionalContactSection1.map((obj) => {
      this.props.dispatch(unregisterField("registration", obj.name));
      this.props.change(obj.name, this.state.resetData[obj.name]);
      if (this.state.popupMode === "add") {
        this.props.untouch(obj.name);
      }
      return null;
    });
    this.state.additionalContactSection2.map((obj) => {
      this.props.dispatch(unregisterField("registration", obj.name));
      this.props.change(obj.name, this.state.resetData[obj.name]);
      if (this.state.popupMode === "add") {
        this.props.untouch(obj.name);
      }
      return null;
    });
    if (this.state.popupMode === "edit") {
      this.setState({
        ...this.generateAdditionalContactFields(this.state.contactCounter - 1),
        popupMode: null,
      });
    } else {
      this.setState({ popupMode: null });
    }
  };

  confirmContactDelete = () => {
    this.props.is_saving(true);
    this.props.connector.deleteContact(
      this.onContactDeleteComplete,
      this.props.formStates["contactId_" + this.state.selectCounter.toString()],
    );
  };

  onContactDeleteComplete = (response) => {
    if (response?.isError) {
      toastPartnerApiFailure(response);
    } else {
      formFields.section13.map((obj, i) => {
        const name = obj.name + "_" + this.state.selectCounter.toString();
        this.props.change(name, null);
        this.props.untouch(name);
        return null;
      });
      formFields.section14.map((obj, i) => {
        const name = obj.name + "_" + this.state.selectCounter.toString();
        this.props.change(name, null);
        this.props.untouch(name);
        return null;
      });
      this.props.change(
        "contactId_" + this.state.selectCounter.toString(),
        null,
      );
      this.props.change(
        "mainContactType_" + this.state.selectCounter.toString(),
        null,
      );
      const selectCounter = this.state.selectCounter;
      let contactSuffix = this.state.contactSuffix.filter(function (number) {
        return number !== selectCounter;
      });
      this.setState({ contactSuffix: contactSuffix, popupMode: null });
    }
    this.props.is_saving(false);
  };

  render() {
    if (!this.props.isSaveAndExit) {
      this.checkDisabled();
      let contactTable = [];
      this.state.contactSuffix?.map((ele, index) =>
        contactTable.push(
          <TR>
            <TD style={{ fontWeight: "bold" }}>
              {this.props.formStates["firstName_" + ele]}{" "}
              {this.props.formStates["lastName_" + ele]}
            </TD>
            <TD>{this.props.formStates["email_" + ele]}</TD>
            <TD>{this.props.formStates["jobRole_" + ele]}</TD>
            <TD>
              <Button
                onClick={() => {
                  this.setState({
                    ...this.generateAdditionalContactFields(ele),
                    popupMode: "edit",
                    selectCounter: ele,
                  });
                }}
                variant="primary"
              >
                <Translate value="registration.ConsolePartnerBtnEdit" />
              </Button>
            </TD>
            <TD>
              <Button
                onClick={() => {
                  this.setState({ popupMode: "delete", selectCounter: ele });
                }}
                variant="warning"
              >
                <Translate value="registration.QBPDelete" />
              </Button>
            </TD>
          </TR>,
        ),
      );
      this.props.onValidateChange(
        Object.values(this.state.sectionValidation).every(Boolean),
      );
      const formName = "registration";
      return (
        <div>
          {this.state.popupMode ? (
            <div className="overlay" style={{ zIndex: "2" }}></div>
          ) : null}
          <Grid>
            <GridRow>
              <GridColumn size={[12, 8, 6, 6]} offsetSize={[0, 2, 3, 3]}>
                <GridRow>
                  <GridColumn>
                    <Heading className="textBold" variant="pageTitle">
                      <Translate value="registration.OnbrdContactSecContactInfo" />
                    </Heading>
                    <p>
                      <Translate value="registration.OnbrdContactSectionHeader" />
                    </p>
                  </GridColumn>
                </GridRow>
                <GridRow>
                  <GridColumn size={[12, 4, 4, 4]}>
                    <Heading variant="subtitle2">
                      <Translate value="registration.OnbrdContactPriConHeader" />
                    </Heading>
                  </GridColumn>
                </GridRow>
                <Well className="well">
                  <GridRow>
                    <GridColumn size={[12, 6, 6, 6]}>
                      <DataSection
                        formStates={this.props.formStates}
                        form={formName}
                        field={formFields.section9}
                        sectionName="section9"
                        updateValidation={this.updateValidation}
                      />
                    </GridColumn>
                    <GridColumn size={[12, 6, 6, 6]}>
                      <DataSection
                        formStates={this.props.formStates}
                        form={formName}
                        field={formFields.section10}
                        sectionName="section10"
                        updateValidation={this.updateValidation}
                      />
                    </GridColumn>
                  </GridRow>
                </Well>
                <GridRow>
                  <GridColumn size={[12, 4, 4, 4]}>
                    <Heading variant="subtitle2">
                      <Translate value="registration.OnbrdContactSecConHeader" />
                    </Heading>
                  </GridColumn>
                </GridRow>
                <Well className="well">
                  <GridRow>
                    <GridColumn size={[12, 6, 6, 6]}>
                      <DataSection
                        formStates={this.props.formStates}
                        form={formName}
                        field={formFields.section11}
                        sectionName="section11"
                        updateValidation={this.updateValidation}
                      />
                    </GridColumn>
                    <GridColumn size={[12, 6, 6, 6]}>
                      <DataSection
                        formStates={this.props.formStates}
                        form={formName}
                        field={formFields.section12}
                        sectionName="section12"
                        updateValidation={this.updateValidation}
                      />
                    </GridColumn>
                  </GridRow>
                </Well>
                <GridRow>
                  <GridColumn size={[12, 4, 4, 4]}>
                    <Heading variant="subtitle2">
                      <Translate value="registration.additional_contacts" />
                    </Heading>
                  </GridColumn>
                </GridRow>
                {this.state.contactSuffix.length > 0 ? (
                  <GridRow style={{ padding: "3% 0" }}>
                    <GridColumn size={[12, 12, 12, 12]}>
                      <Table>
                        <THead>
                          <TH>
                            <Translate value="registration.ReAssignContactNameLabel" />
                          </TH>
                          <TH>
                            <Translate value="registration.OnbrdCertContactEmail" />
                          </TH>
                          <TH>
                            <Translate value="registration.job_role_ws" />
                          </TH>
                        </THead>
                        <TBody>{contactTable}</TBody>
                      </Table>
                    </GridColumn>
                  </GridRow>
                ) : null}
                <GridRow>
                  <GridColumn size={[12, 6, 6, 6]}>
                    <Button
                      onClick={() => {
                        this.setState({ popupMode: "add" });
                      }}
                      variant="cta"
                    >
                      <Translate value="registration.add_additional_contacts" />
                    </Button>
                    {Boolean(
                      this.state.popupMode === "add" ||
                      this.state.popupMode === "edit",
                    ) ? (
                      <Dialog
                        className="customDialog"
                        variant="confirmation"
                        title={
                          this.state.popupMode === "add" ? (
                            <Translate value="registration.add_additional_contacts" />
                          ) : (
                            <Translate value="registration.ConsolePartnerBtnEdit" />
                          )
                        }
                        confirmLabel={
                          <Translate value="registration.TrngSaveClose" />
                        }
                        confirmDisabled={
                          !Object.values(this.state.popupValidation).every(
                            Boolean,
                          )
                        }
                        onConfirm={() => {
                          this.additionalContactSave();
                        }}
                        onCancel={() => {
                          this.additionalContactCancel();
                        }}
                        cancelLabel={
                          <Translate value="registration.TrngClose" />
                        }
                      >
                        <Provider store={store}>
                          <GridRow>
                            <GridColumn size={[12, 12, 12, 12]}>
                              <Translate value="registration.msg_add_contact_1" />
                              <br />
                              <br />
                            </GridColumn>
                          </GridRow>
                          <GridRow>
                            <GridColumn size={[12, 6, 6, 6]}>
                              <DataSection
                                formStates={this.props.formStates}
                                form={formName}
                                field={this.state.additionalContactSection1}
                                sectionName="additionalContact1"
                                updateValidation={this.popupValidation}
                              />
                            </GridColumn>
                            <GridColumn size={[12, 6, 6, 6]}>
                              <DataSection
                                formStates={this.props.formStates}
                                form={formName}
                                field={this.state.additionalContactSection2}
                                sectionName="additionalContact2"
                                updateValidation={this.popupValidation}
                              />
                            </GridColumn>
                          </GridRow>
                        </Provider>
                      </Dialog>
                    ) : null}
                  </GridColumn>
                </GridRow>
              </GridColumn>
              <GridRow>
                <GridColumn>
                  {Boolean(this.state.popupMode === "delete") ? (
                    <Dialog
                      className="customDialog"
                      variant="confirmation"
                      title={
                        <Translate value="registration.confirm_deletion" />
                      }
                      confirmLabel={
                        <Translate value="registration.QBPDelete" />
                      }
                      onConfirm={() => {
                        this.confirmContactDelete();
                      }}
                      onCancel={() => {
                        this.setState({ popupMode: null });
                      }}
                      cancelLabel={<Translate value="registration.TrngClose" />}
                    >
                      <Translate value="registration.delete_confirm_msg" />{" "}
                      {
                        this.props.formStates[
                          "firstName_" + this.state.selectCounter
                        ]
                      }{" "}
                      {
                        this.props.formStates[
                          "lastName_" + this.state.selectCounter
                        ]
                      }{" "}
                      <Translate value="registration.delete_confirm_msg1" />
                    </Dialog>
                  ) : null}
                </GridColumn>
              </GridRow>
            </GridRow>
          </Grid>
        </div>
      );
    } else {
      return <SaveNExit />;
    }
  }
}

AddContacts = reduxForm({
  form: "registration",
  destroyOnUnmount: false, //        <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(AddContacts);

function mapStateToProps(state) {
  return {
    formStates: getFormValues("registration")(state), // here 'form' is the name you have given your redux form
  };
}

export default connect(mapStateToProps)(AddContacts);
